<template>
<section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters">
            <el-form-item v-if="state =='1' || state =='5' || state =='6'">
                <el-select v-model="filters.cardState" placeholder="卡状态" clearable>
                    <el-option v-for="item in options_cardstate" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="filters.cardType" placeholder="套餐" filterable clearable>
                    <el-option v-for="item in options_cardtype" :label="item.name" :value="item.name">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-date-picker v-model="filters.expireBt" type="date" placeholder="到期时间开始" :picker-options="pickerOptions0">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-date-picker v-model="filters.expireEt" type="date" placeholder="到期时间结束" :picker-options="pickerOptions0">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-input v-model="filters.cardSegBt" placeholder="卡号段开始"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input v-model="filters.cardSegEt" placeholder="卡号段截止"></el-input>
            </el-form-item>
            <el-form-item>
                <el-date-picker v-model="filters.inSkuBt" type="date" placeholder="入库开始日期" :picker-options="pickerOptions0">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-date-picker v-model="filters.inSkuEt" type="date" placeholder="入库截止日期" :picker-options="pickerOptions0">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-date-picker v-model="filters.outSkuBt" type="date" placeholder="出库开始日期" :picker-options="pickerOptions0">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-date-picker v-model="filters.outSkuEt" type="date" placeholder="出库截止日期" :picker-options="pickerOptions0">
                </el-date-picker>
            </el-form-item>

            <template v-if="sysUserName!='二级服务商'">
                <el-form-item>
                    <el-select v-model="filters.servicerLevel" placeholder="服务商等级" clearable>
                        <el-option v-for="item in options_servicerLevel" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-select v-model="filters.servicerName" placeholder="服务商名称" filterable clearable>
                        <el-option v-for="item in options_servicerman" :label="item.servicerName" :value="item.userid+''">
                        </el-option>
                    </el-select>
                </el-form-item>
            </template>

            <el-form-item>
                <el-input v-model="filters.likeCardKey" placeholder="输卡号/ICCID/IMSI/查询码"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" v-on:click="getCards">查询</el-button>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="exportExcel">导出EXCEL</el-button>
            </el-form-item>
        </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="cards" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
        <el-table-column prop="msisdn" label="卡号" width="150" sortable>
        </el-table-column>
        <el-table-column prop="iccid" label="ICCID" width="210" sortable>
        </el-table-column>
        <el-table-column prop="imsi" label="IMSI" width="180" sortable>
        </el-table-column>
        <el-table-column prop="querycode" label="查询代码" width="120" sortable>
        </el-table-column>
        <el-table-column prop="packagename" label="套餐名称" min-width="200" sortable>
        </el-table-column>
        <el-table-column prop="cardstate" label="卡状态" min-width="100" sortable>
        </el-table-column>
        <el-table-column prop="openAccountTime" label="开户时间" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="addtime" label="入库日期" min-width="120" sortable>
        </el-table-column>
        <el-table-column prop="outSkuDate" label="出库日期" min-width="120" sortable>
        </el-table-column>
        <el-table-column prop="activeDate" label="激活日期" min-width="120" sortable>
        </el-table-column>
        <el-table-column prop="expiretime" label="到期时间" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="servicername" label="服务商名称" min-width="180" sortable>
        </el-table-column>
        <el-table-column prop="contactmobile" label="联系人" min-width="180" sortable>
        </el-table-column>
        <el-table-column prop="currentmoney" label="用户余额" min-width="120" sortable>
        </el-table-column>
        <el-table-column prop="totalgprs" label="总流量" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="currentgprs" label="剩余流量" min-width="120" sortable>
        </el-table-column>
        <el-table-column prop="usedsmsnum" label="短信使用条数" min-width="150" sortable>
        </el-table-column>
        <el-table-column prop="remark" label="备注信息" min-width="150" sortable>
        </el-table-column>

        <el-table-column label="操作" width="80" fixed="right">
            <template scope="scope" v-if="sysUserName!=null">
                <template v-if="sysUserName=='管理员' || sysUserName=='一级服务商'">
                    <el-button size="small" @click="handleMore(scope.$index, scope.row)">详细</el-button>
                </template>
                <template v-else>
                    <el-button size="small" @click="handleMore(scope.$index, scope.row)">详细</el-button>
                </template>
            </template>
        </el-table-column>
    </el-table>

    <!--工具条(分页)-->
    <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
    </el-col>

    <!--卡号信息详情界面-->
    <cardinfo ref="cardinfo"></cardinfo>

</section>
</template>

<script>
import util from '../../common/js/util'
import constant from '../../common/js/constant'
//import NProgress from 'nprogress'
import {
    getCardListPageByState,
    getChildUsers,
    getAllPackList,
    getCardListPageByExpire,
    getCardListPageByWarming
} from '../../api/api';
import Cardinfo from '../../components/card_info.vue';

export default {
    components: {
        cardinfo: Cardinfo
    },
    data() {
        return {
            sysUserName: '',
            pickerOptions0: {
                disabledDate(time) {
                    return false;
                }
            },
            options_cardstate: constant.opt_cardstate,
            options_cardtype: constant.opt_cardtype,
            options_cardapicode: constant.opt_cardapicode,
            options_servicerman: constant.opt_servicerman,
            options_servicerLevel: [],
            filters: {
                //卡状态
                cardState: '',
                //卡套餐名称类型
                cardType: '',
                //激活开始日期
                activeBt: '',
                //激活截至日期
                activeEt: '',
                //到期开始日期
                expireBt: '',
                //到期截至日期
                expireEt: '',
                //入库开始时间
                inSkuBt: '',
                //入库截止时间
                inSkuEt: '',
                //出库开始时间
                outSkuBt: '',
                //出库截止时间
                outSkuEt: '',
                //卡号段开始
                cardSegBt: '',
                //卡号段截止		                cardSegEt: '',
                //服务商等级		                servicerLevel: '',
                //服务商名称		                servicerName: '',
                //模糊查询卡关键字
                likeCardKey: '',
                tempState: ''
            },
            cards: [],
            total: 0, //列表总条数
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            listLoading: false,
            sels: [], //列表选中列
            state: ''
        }
    },
    methods: {
        selsChange: function (sels) {
            this.sels = sels;
        },
        exportExcel() {
            this.filters.inSkuBt = (!this.filters.inSkuBt || this.filters.inSkuBt == '') ? '' : util.formatDate.format(new Date(this.filters.inSkuBt), 'yyyy-MM-dd');
            this.filters.inSkuEt = (!this.filters.inSkuEt || this.filters.inSkuEt == '') ? '' : util.formatDate.format(new Date(this.filters.inSkuEt), 'yyyy-MM-dd');
            this.filters.outSkuBt = (!this.filters.outSkuBt || this.filters.outSkuBt == '') ? '' : util.formatDate.format(new Date(this.filters.outSkuBt), 'yyyy-MM-dd');
            this.filters.outSkuEt = (!this.filters.outSkuEt || this.filters.outSkuEt == '') ? '' : util.formatDate.format(new Date(this.filters.outSkuEt), 'yyyy-MM-dd');
            this.filters.activeBt = (!this.filters.activeBt || this.filters.activeBt == '') ? '' : util.formatDate.format(new Date(this.filters.activeBt), 'yyyy-MM-dd');
            this.filters.activeEt = (!this.filters.activeEt || this.filters.activeEt == '') ? '' : util.formatDate.format(new Date(this.filters.activeEt), 'yyyy-MM-dd');
            this.filters.expireBt = (!this.filters.expireBt || this.filters.expireBt == '') ? '' : util.formatDate.format(new Date(this.filters.expireBt), 'yyyy-MM-dd');
            this.filters.expireEt = (!this.filters.expireEt || this.filters.expireEt == '') ? '' : util.formatDate.format(new Date(this.filters.expireEt), 'yyyy-MM-dd');
            if(this.state != null && this.state == '1'){//全部卡列表
                this.filters.tempState = '';
            }else if(this.state != null && this.state == '2'){//正常卡列表
                this.filters.tempState = '00';
            }else if(this.state != null && this.state == '3'){//待激活
                this.filters.tempState = '07';
            }else if(this.state != null && this.state == '4'){//已停机
                this.filters.tempState = '01,02';
            }

            let para = "";
            para += "cardState=" + ((!this.filters.cardState || this.filters.cardState == '') ? '' : this.filters.cardState);
            para += "&cardType=" + ((!this.filters.cardType || this.filters.cardType == '') ? '' : this.filters.cardType);
            para += "&inSkuBt=" + this.filters.inSkuBt;
            para += "&inSkuEt=" + this.filters.inSkuEt;
            para += "&outSkuBt=" + this.filters.outSkuBt;
            para += "&outSkuEt=" + this.filters.outSkuEt;
            para += "&activeBt=" + this.filters.activeBt;
            para += "&activeEt=" + this.filters.activeEt;
            para += "&expireBt=" + this.filters.expireBt;
            para += "&expireEt=" + this.filters.expireEt;
            para += "&cardSegBt=" + ((!this.filters.cardSegBt || this.filters.cardSegBt == '') ? '' : this.filters.cardSegBt);
            para += "&cardSegEt=" + ((!this.filters.cardSegEt || this.filters.cardSegEt == '') ? '' : this.filters.cardSegEt);
            para += "&likeCardKey=" + ((!this.filters.likeCardKey || this.filters.likeCardKey == '') ? '' : this.filters.likeCardKey);
            para += "&servicerLevel=" + ((!this.filters.servicerLevel || this.filters.servicerLevel == '') ? '' : this.filters.servicerLevel);
            para += "&servicerName=" + ((!this.filters.servicerName || this.filters.servicerName == '') ? '' : this.filters.servicerName);
            
            if(this.state != null && this.state == '5'){
                location.href = "/api/main/Cards/cardExpireExportXls?" + para;
            }else if(this.state != null && this.state == '6'){
                location.href = "/api/main/Cards/cardWarmingExportXls?" + para;
            }else{
                para += "&tempState=" + ((!this.filters.tempState || this.filters.tempState == '') ? '' : this.filters.tempState);
                location.href = "/api/main/Cards/cardstateExportXls?" + para;
            } 
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getCards();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getCards();
        },
        //获取卡号列表
        getCards() {
            let para = {
                pageSize: this.pageSize,
                pageNum: this.currentPage
            };

            if(this.state != null && this.state == '1'){//全部卡列表
                this.filters.tempState = '';
            }else if(this.state != null && this.state == '2'){//正常卡列表
                this.filters.tempState = '00';
            }else if(this.state != null && this.state == '3'){//待激活
                this.filters.tempState = '07';
            }else if(this.state != null && this.state == '4'){//已停机
                this.filters.tempState = '01,02';
            }

            this.filters.likeCardKey = this.filters.likeCardKey.trim();
            para = Object.assign(para, this.filters);
            para.activeBt = (!para.activeBt || para.activeBt == '') ? '' : util.formatDate.format(new Date(para.activeBt), 'yyyy-MM-dd');
            para.activeEt = (!para.activeEt || para.activeEt == '') ? '' : util.formatDate.format(new Date(para.activeEt), 'yyyy-MM-dd');
            para.expireBt = (!para.expireBt || para.expireBt == '') ? '' : util.formatDate.format(new Date(para.expireBt), 'yyyy-MM-dd');
            para.expireEt = (!para.expireEt || para.expireEt == '') ? '' : util.formatDate.format(new Date(para.expireEt), 'yyyy-MM-dd');
            para.inSkuBt = (!para.inSkuBt || para.inSkuBt == '') ? '' : util.formatDate.format(new Date(para.inSkuBt), 'yyyy-MM-dd');
            para.inSkuEt = (!para.inSkuEt || para.inSkuEt == '') ? '' : util.formatDate.format(new Date(para.inSkuEt), 'yyyy-MM-dd');
            para.outSkuBt = (!para.outSkuBt || para.outSkuBt == '') ? '' : util.formatDate.format(new Date(para.outSkuBt), 'yyyy-MM-dd');
            para.outSkuEt = (!para.outSkuEt || para.outSkuEt == '') ? '' : util.formatDate.format(new Date(para.outSkuEt), 'yyyy-MM-dd');

            if(this.state != null && this.state == '5'){
                this.listLoading = true;
                getCardListPageByExpire(para).then((res) => {
                    this.total = res.data.total;
                    this.cards = res.data.list;
                    this.listLoading = false;
                });
            }else if(this.state != null && this.state == '6'){
                this.listLoading = true;
                getCardListPageByWarming(para).then((res) => {
                    this.total = res.data.total;
                    this.cards = res.data.list;
                    this.listLoading = false;
                });
            }else{
                this.listLoading = true;
                getCardListPageByState(para).then((res) => {
                    this.total = res.data.total;
                    this.cards = res.data.list;
                    this.listLoading = false;
                });
            }
        },
        //显示卡号详细界面
        handleMore: function (index, row) {
            this.$refs.cardinfo.showCardDetail(row.msisdn);
        },

    },
    mounted() {
        this.state = this.$route.params.state;
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            if (user.userlevel == 0) {
                this.sysUserName = '管理员';
                this.options_servicerLevel = [{
                        "label": "管理员",
                        "value": "0"
                    },
                    {
                        "label": "一级服务商",
                        "value": "1"
                    },
                    {
                        "label": "二级服务商",
                        "value": "2"
                    }
                ];
            } else if (user.userlevel == 1) {
                this.sysUserName = '一级服务商';
                this.options_servicerLevel = [{
                        "label": "一级服务商",
                        "value": "1"
                    },
                    {
                        "label": "二级服务商",
                        "value": "2"
                    }
                ];
            } else if (user.userlevel == 2) {
                this.sysUserName = '二级服务商';
                this.options_servicerLevel = [{
                    "label": "二级服务商",
                    "value": "2"
                }];
            }
        }

        let para = {};
        getAllPackList(para).then((res) => {
            var arr = new Array();
            if(res.data != null && res.data.length >0){
                for(var i=0;i<res.data.length;i++){
                    if(res.data[i].type != '叠加卡'){
                        arr.push(res.data[i]);
                    }
                }
            }
            this.options_cardtype = arr;
        });
        getChildUsers(para).then((res) => {
            this.options_servicerman = res.data;
        });

        this.getCards();
    }
}
</script>



// WEBPACK FOOTER //
// maincardlist.vue?0add57b2